import { inject, observer } from "mobx-react";
// import { useEffect } from "react";
import "./about.scss";
import person from "../../constants/img/person.jpg";
// import emailImg from '../../constants/img/emai2.png'
import {
  Box,
  Container,
  Grid,
  Typography,
  useTheme,
  Card,
  CardContent,
} from "@mui/material";
import { Email, LocationOn, MailOutline } from "@mui/icons-material";
import BigImage from "../../components/BigImage/BigImage";

function About() {

  return (
    <Container className="about-body" maxWidth="xl">
      <Box className="about-title" color="primary.light">
        <Typography variant="h3" component="div" className="about-title-text">
          Contact us
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid
          item
          md={12}
          sm={12}
          xs={12}
          // sx={}
          container
          direction="column"
          spacing={4}
        >
          <Grid item>
            <CardContent sx={{ ml: 1 }}>
              <Card sx={{ minWidth: 300, borderLeft: "6px solid #f6903d" }}>
                <CardContent sx={{ ml: 1 }} sm={12}>
                  <Grid container direction="row" spacing={4}>
                    <Grid item sm={2.5}>
                      {/* <Box > */}
                      <BigImage src={person} maxWidth={200} />
                      {/* </Box> */}
                    </Grid>
                    <Grid item sm={9.5}>
                      <Grid container direction="column">
                        <Grid item>
                          <Typography
                            variant="h3"
                            component="div"
                            color="#35c090"
                            sx={{
                              fontSize: "30px",
                              fontWeight: "bold",
                              mb: 3,
                              mt: 3,
                            }}
                          >
                            Leyi Wei
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography
                            variant="h7"
                            color="primary"
                            component="div"
                            className="info-label"
                            sx={{ color: "black", fontSize: "18px" }}
                            lineHeight={2}
                          >
                            <MailOutline /> Post Code: 250101
                          </Typography>
                          <Typography
                            variant="h7"
                            color="primary"
                            component="div"
                            className="info-label"
                            sx={{ color: "black", fontSize: "18px" }}
                            lineHeight={2}
                          >
                            <Email /> E-mail: weileyi@sdu.edu.cn
                          </Typography>
                          <Typography
                            variant="h7"
                            color="primary"
                            component="div"
                            className="info-label"
                            sx={{ color: "black", fontSize: "18px" }}
                            lineHeight={2}
                          >
                            <LocationOn />
                            Room 404,Joint SDU-NTU Centre for Artificial
                            Intelligence Research (C-FAIR) Shandong University,
                            Jinan, Shandong, China
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </CardContent>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default inject("store")(observer(About));
